import styled from "@emotion/styled/macro"
import { fontSize, size } from "@styles/theme"
import styles from '@styles/plus-icon.module.css'
import { Accordion } from "@base-ui/react"

const leftMargin = size(3)

const AccordionItemContainer = styled(Accordion.Item)``

const AccordionHeader = styled(Accordion.Header)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #333333;
  margin: 0;
  padding: 0;
`

const AccordionTrigger = styled(Accordion.Trigger)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  padding: ${size(2)};
  padding-left: ${leftMargin};
  font-weight: 500;
  letter-spacing: 0.05rem;
  font-size: ${fontSize('xs')};
  margin: 0;
  height: ${size(7)};
`

const TriggerLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

const AccordionPanel = styled(Accordion.Panel)`
  min-height: ${size(10)};
  margin: ${size(1)};
  background-color: rgba(255,255,255,0.1);
  border-radius: 15px;
`

const AccordionContent = styled.div`
  display: flex;
  align-items: center;
  padding: ${size(2)};
  min-height: inherit;
`

function PlusIcon({ ...rest }) {
  return (
    <svg viewBox="0 0 12 12" fill="currentcolor" {...rest}>
      <path d="M6.75 0H5.25V5.25H0V6.75L5.25 6.75V12H6.75V6.75L12 6.75V5.25H6.75V0Z" />
    </svg>
  );
}

const AccordionItem = ({ value, headerText, HeaderIcon, children }) => {
  return (
    <AccordionItemContainer value={value}>
      <AccordionHeader>
        <AccordionTrigger>
          <TriggerLeft>
            {HeaderIcon && <><HeaderIcon />&nbsp;&nbsp;&nbsp;</>}
            {headerText}
          </TriggerLeft>
          <PlusIcon className={styles.PlusIcon} />
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionPanel>
        <AccordionContent>
          {children}
        </AccordionContent>
      </AccordionPanel>
    </AccordionItemContainer>
  )
}

export default AccordionItem
